import axios from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
  _file?: File;
  key?: string;
}
const publicRoutes = ["/core/countries"];

const WebService = {
  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? new URLSearchParams(props.body) : props.body,
          { headers }
        )
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  uploadAPI: function (props: PropData) {
    const formData = new FormData();
    if (props._file && props.key) formData.append(props.key, props._file);
    if (props.body)
      Object.keys(props.body).forEach((key) =>
        formData.append(key, props.body[key])
      );

    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, formData, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  putAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const isPublic = publicRoutes.some((route) =>
        props.action.startsWith(route)
      );

      const headers: any = {};
      if (!isPublic && localStorage.getItem("access_token")) {
        headers.Authorization =
          "Bearer " + localStorage.getItem("access_token");
      }

      axios
        .get(`${BASE_URL}${props.action}`, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    if (error?.response) error = error.response;
    let errorMessage = "Server Not Responding";

    if (error?.status === 401) {
      errorMessage = "Unauthorized";
      this.logout();
    } else if (error?.status === 500) {
      errorMessage =
        error?.data?.ErrorDetails?.message ||
        "An unknown exception occurred. Please contact administrator.";
    } else if (error?.data?.message) {
      errorMessage = error.data.message;
    }

    toast.error(errorMessage);
    return errorMessage;
  },
  addLoader(id: any) {
    if (id) {
      const button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = true;
        const loader = document.createElement("span");
        loader.className = "loader";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      const button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = false;
        if (button.childNodes.length > 0)
          button.removeChild(button.childNodes[0]);
      }
    }
  },

  logout() {
    window.location.href = "/login";
  },

  getBaseUrl() {
    return BASE_URL;
  },
};

export default WebService;
